import { useState } from 'react';
import './Awards.scss';

// Images imports
import one from "../../assets/Images/Home/Hero/Awards/one.svg"
import two from "../../assets/Images/Home/Hero/Awards/two.svg"
import three from "../../assets/Images/Home/Hero/Awards/three.svg"
import four from "../../assets/Images/Home/Hero/Awards/four.svg"
import cluster from "../../assets/Images/Home/Hero/Awards/cluster.svg"
import leftArrow from "../../assets/Images/Home/Hero/Awards/arrow-narrow-left.svg"
import rightArrow from "../../assets/Images/Home/Hero/Awards/arrow-narrow-right.svg"

const AWARDS_DATA = [
  { id: 1, title: 'Top AI Development Company by Mobile App Daily', img: one },
  { id: 2, title: 'Top Blockchain App Developers by TopDevelopers', img: two },
  { id: 3, title: 'Top App Development Company by Appfutura', img: three },
  { id: 4, title: 'Top Blockchain App Developers UK by GoodFirms', img: four },
];

// We double the array to have enough cards (8) to fill the screen and off-screen areas safely.
// We MUST generate a unique string ID so React tracks the DOM nodes correctly when shifting the array.
const INITIAL_ITEMS = [...AWARDS_DATA, ...AWARDS_DATA].map((item, index) => ({
  ...item,
  uniqueId: `${item.id}-clone-${index}` 
}));

export default function Awards() {
  const [items, setItems] = useState(INITIAL_ITEMS);
  const [slideIndex, setSlideIndex] = useState(1); // Always rests securely at 1
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false); // Prevents rapid clicking from breaking the loop

  const nextSlide = () => {
    if (isAnimating) return;
    setIsAnimating(true);
    setIsTransitioning(true);
    setSlideIndex(2); // Animate forward
  };

  const prevSlide = () => {
    if (isAnimating) return;
    setIsAnimating(true);
    setIsTransitioning(true);
    setSlideIndex(0); // Animate backward
  };

  // Magic happens here: manipulating the array instantly after the slide completes
  const handleTransitionEnd = (e) => {
    // Prevent bubbled transition events from children (like hover effects) from triggering this
    if (e.target !== e.currentTarget) return; 

    setIsTransitioning(false); // Turn off CSS transitions for the silent snap
    
    if (slideIndex === 2) {
      // We moved right. Pluck the first item and push it to the end of the array.
      setItems((prev) => [...prev.slice(1), prev[0]]);
      setSlideIndex(1); // Silently snap back to the resting position
    } else if (slideIndex === 0) {
      // We moved left. Pluck the last item and unshift it to the front of the array.
      setItems((prev) => [prev[prev.length - 1], ...prev.slice(0, -1)]);
      setSlideIndex(1); // Silently snap back to the resting position
    }
    
    // Unlock the buttons after a tiny delay to ensure React commits the silent snap first
    setTimeout(() => {
      setIsAnimating(false);
    }, 50);
  };

  return (
    <section className="awards-section">
      
      {/* Header Section */}
      <div className="aw-header-container">
        <div className="aw-capsule">
          <div className="icon-wrapper">
            <div className="icon-blur" aria-hidden="true"></div>
            <img src={cluster} alt="cluster" className="aw-icon" />
          </div>
          <span>Awards</span>
        </div>

        <h2 className="aw-heading">
          Our Awards Reflect
          <br />
          Our Dedication to
          <br />
          <span className="highlight-box">Superior Solutions</span>
        </h2>
      </div>

      {/* Carousel Section */}
      <div className="aw-carousel-container">
        
        {/* Left Arrow */}
        <button 
          className="aw-nav-arrow prev" 
          onClick={prevSlide} 
          aria-label="Previous slide"
          disabled={isAnimating} // Optionally visually disable if you want
        >
          <img src={leftArrow} alt="leftArrow" className="arrow-icon" />
        </button>

        {/* Carousel Viewport */}
        <div className="aw-viewport">
          <div 
            className="aw-track"
            style={{ 
              transform: `translateX(calc(-${slideIndex} * (var(--card-width) + var(--card-gap))))`,
              transition: isTransitioning ? 'transform 0.5s cubic-bezier(0.25, 1, 0.5, 1)' : 'none'
            }}
            onTransitionEnd={handleTransitionEnd}
          >
            {items.map((award) => (
              <div className="aw-card" key={award.uniqueId}>
                <div className="aw-card-image-wrapper">
                  <img src={award.img} alt={award.title} className="aw-badge-img" />
                </div>
                <h6 className="aw-card-title">{award.title}</h6>
              </div>
            ))}
          </div>
        </div>

        {/* Right Arrow */}
        <button 
          className="aw-nav-arrow next" 
          onClick={nextSlide} 
          aria-label="Next slide"
          disabled={isAnimating}
        >
          <img src={rightArrow} alt="rightArrow" className="arrow-icon" />
        </button>

      </div>
    </section>
  );
}